import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const getComponentTypes = async () => {
  const response = await axiosInstance.get(`${API_URL}/component-type`);
  return response.data;
};

export const getComponentTypeById = async (id) => {
  const response = await axiosInstance.get(`${API_URL}/component-type/${id}`);
  return response.data;
};

export const createComponentType = async (data) => {
  const response = await axiosInstance.post(`${API_URL}/component-type`, data);
  return response.data;
};

export const updateComponentType = async (id, data) => {
  const response = await axiosInstance.put(`${API_URL}/component-type/${id}`, data);
  return response.data;
};

export const deleteComponentType = async (id) => {
  const response = await axiosInstance.delete(`${API_URL}/component-type/${id}`);
  return response.data;
};
